import i18n from "i18next";
export const CallDirection = {
    DirectionInbound: "directionInbound",
    DirectionOutbound: "directionOutbound",
};
export const ConversationType = {
    TypeWebConference: "typeWebConference",
    TypeOther: "typeOther",
};
export const DropdownFilterValues = [...Object.values(CallDirection), ...Object.values(ConversationType)];
export const DropdownFilterKeys = {
    get [CallDirection.DirectionInbound]() { return i18n.t('Incoming_'); },
    get [CallDirection.DirectionOutbound]() { return i18n.t('Outgoing_'); },
    get [ConversationType.TypeWebConference]() { return i18n.t('Web.conference_'); },
    get [ConversationType.TypeOther]() { return i18n.t('Other_'); },
};
export const AiStatus = {
    Processing: "processing",
    Success: "success",
    Failed: "processing_failed",
};
export const AiFailureReason = {
    None: "None",
    LimitReached: "LimitReached",
    General: "General",
    Disabled: "Disabled",
};
